import VuexORM from '@vuex-orm/core'
import createStore from '../store'
import { BaseResource as Resource } from '../defaults/resource'

const inject = {
  install (components, options) {
    components.Model[options.name] = options.inject
  }
}

export default ({ store, app }) => {
  const vuexStore = store || createStore()

  const models = [
    Resource,
    ...Object.values(Resource.Models)
  ]

  const database = new VuexORM.Database()
  models.forEach((model) => { database.register(model) })

  VuexORM.use(inject, {
    name: '$store',
    inject: store
  })

  VuexORM.use(inject, {
    name: '$axios',
    inject: app.$axios
  })

  VuexORM.install(database)(vuexStore)
}
